import React from 'react';
import { cn } from '@/lib/utils';
import { MobileActionBar } from './MobileActionButton';

/**
 * MobilePageHeader — responsive page header that fixes the common mobile overflow
 * where a narrow heading is squeezed beside wide action buttons (spec 1.3, e.g.
 * the Service Providers "Import Vendors / Add Service Provider" issue).
 *
 * Mobile: heading + description take the FULL width; actions drop onto their own
 * row(s) below in a compact, wrapping bar — never pushing past the viewport.
 * sm+ : title on the left, actions on the right at natural width (preserves the
 * existing desktop presentation).
 *
 * props: { title, description?, actions?, className, testid }
 */
export const MobilePageHeader = ({ title, description, actions, className, testid = 'mobile-page-header' }) => (
  <div
    data-testid={testid}
    className={cn('mb-4 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between', className)}
  >
    <div className="min-w-0">
      <h1 className="text-xl font-bold leading-tight text-[#0E2A47] sm:text-2xl" data-testid={`${testid}-title`}>
        {title}
      </h1>
      {description && <p className="mt-1 text-sm text-slate-500">{description}</p>}
    </div>
    {actions && (
      <MobileActionBar testid={`${testid}-actions`} className="sm:w-auto sm:shrink-0">
        {actions}
      </MobileActionBar>
    )}
  </div>
);

export default MobilePageHeader;
